<template>
 <div :class="windowClass">
    <v-row no-gutters>
            <v-col xs="12" class="pa-2">
                    <v-card>
                        <v-card-title>
                        <v-icon large left color="secondary">mdi-cogs</v-icon> MANAGE SETTINGS
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text>
                             <v-data-table
                                class="va-table"
                                :headers="headers"
                                :search="search"
                                :items="SETTINGS"
                                hide-default-footer
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                         <td width="30%">
                                                {{item.description}}
                                         </td>
                                         <td>
                                           <template v-if="item.data_type=='array'">
                                                <v-chip small color="teal"
                                                 class="ma-1" v-for="(val, v) in item.value.split(',')" 
                                                 :key="v+'-'+index"
                                                  text-color="white"
                                                >
                                                <v-icon left small color="error" @click="setting =item,removeValue(v)">mdi-close</v-icon>
                                                  {{val}}
                                                </v-chip>
                                           </template>
                                           <template v-else>
                                              {{item.value}}
                                           </template>
                                           
                                           <v-icon color="warning" right @click="setting=item, text= editVal(), form=true">
                                             {{item.data_type=='array'?'mdi-plus-box':'mdi-pencil'}}
                                             </v-icon>
                                         </td>
                                    </tr>
                                    </tbody>
                                </template>
                                </v-data-table>
                        </v-card-text>
                    </v-card>
            </v-col>
    </v-row>
    <va-text-edit-form :show="form" state="update" :data="text" @DialogEvent="formEvent" />
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        text:'',
        state: 'new',
        setting: {},
        search:'',
        settings:[],
        headers: [
            { text: 'Name', sortable: false},
            { text: 'Value', sortable: false}
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
      if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.SET_MENUS()
          this.GET_SETTINGS()
      }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      SETTINGS(){
        return this.$store.state.settings
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      editVal(){
          if( this.setting.data_type == 'text') {
            return  this.setting.value 
          } else if(this.setting.data_type=='array'){ //if array add only...start empty
            return ''
          }
      },
      val_array(data){
          return data.split(',')
      },
      formEvent(data){
          this.form = false
          if(data.action != 'close') {
            if( this.setting.data_type == 'text') {
              this.setting.value = data.text
            } else if( this.setting.data_type=='array'){ //if array add only...start empty
                
               // this.setting.value=  this.val_array(this.setting.value).push(data.text)
              var val = []
              val = this.setting.value.split(',')
              val[val.length] = data.text
              this.setting.value = val.toString()
            }
            this.Update()
          }
      },
      removeValue(i){
          var val = []
          val = this.setting.value.split(',')
          val.splice(i,1)
          this.setting.value = val.toString()
          this.Update()
      },
      Update: function() { 
            this.$http.post("setting/update", this.setting).then(response => {
              response.data.status?this.VA_ALERT('success', response.data.message):this.VA_ALERT('error', response.data.message)
          }).catch(e => {
           console.log(e.data)
         })
     }
    }
  }
</script>